import store from '@/store';
import {markModule} from '@/routes/guards';

const ChildProfile = () => import(/* webpackChunkName: "child-module" */ '@views/child/profile');
const Info = () => import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/Info.vue');
const Approvals = () => import(/* webpackChunkName: "child-module" */ '@views/child/profile/views/Approvals.vue');
const Maps = () => import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/Maps.vue');
const Development = () => import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/Development.vue');
const Map = () => import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/Map.vue');
const Plans = () =>  import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/ChildPlans.vue');
const Guardians = () => import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/Guardians.vue');
const GuardianDiary = () => import( /* webpackChunkName: "child-module" */ '@views/child/profile/views/GuardianDiary.vue');
const AbsenceCalendar = () => import('@views/child/profile/views/AbsenceCalendar.vue');
const Files = () => import('@views/child/profile/views/Files.vue');
const GuardianInvoices = () => import(/* webpackChunkName: "child-module" */ '@views/child/profile/views/GuardianInvoices.vue');
const GuardianInvoice = () => import(/* webpackChunkName: "child-module" */ '@views/child/profile/views/GuardianInvoice.vue');
export default [
    {
        path: '/child/:child_id',
        components: { base: ChildProfile },
        children: [
            {
                path: '',
                name: 'child.profile',
                components: { child: Info }
            },
            {
                path: 'calendar',
                name: 'child.calendar',
                components: { child: AbsenceCalendar }
            },
            {
                path: 'approvals',
                name: 'child.approvals',
                components: { child: Approvals },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canViewChildApprovals || store.getters.canEditChildApprovals) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'maps',
                name: 'child.maps',
                components: { child: Maps },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessChildMaps || store.getters.canParentAccessChildMaps) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'plans',
                name: 'child.plans',
                components: { child: Plans },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessChildPlans) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'parents',
                name: 'child.parents',
                components: { child: Guardians },
                beforeEnter: (to, from, next) => {
                    if (store.getters.canAccessChildGuardians) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                }
            },
            {
                path: 'diary',
                name: 'child.diary',
                components: { child: GuardianDiary }
            },
            {
                path: 'development',
                name: 'child.development',
                components: { child: Development },
                beforeEnter: markModule('child_dev', (to, from, next) => {
                    if (store.getters.canViewChildDevelopment || store.getters.canEditChildDevelopment || store.getters.canViewChildDevelopmentParent) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                })
            },
            {
                path: 'files',
                name: 'child.files',
                components: { child: Files },
                beforeEnter: markModule('child_profile_files', (to, from, next) => {
                    if (store.getters.childProfileSettings.child_profile_files_enabled && (store.getters.canAccessChildFilesEmployee || store.getters.canAccessChildFilesGuardian)) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                })
            },
            {
                path: 'invoices',
                name: 'child.invoices',
                components: { child: GuardianInvoices },
                beforeEnter: markModule('invoices', (to, from, next) => {
                    if (store.getters.canAccessGuardianInvoices || store.getters.canAccessGuardianInvoicesGuardian) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                })
            },
            {
                path: 'invoices/:invoice_id',
                name: 'child.guardian-invoice',
                components: { child: GuardianInvoice},
                beforeEnter: markModule('invoices', (to, from, next) => {
                    if (store.getters.canAccessGuardianInvoices || store.getters.canAccessGuardianInvoicesGuardian) {
                        next();
                    } else {
                        next({ path: '/access-restricted' });
                    }
                })
            }
        ]
    },
    {
        path: '/child/:child_id/maps/:map_id',
        name: 'child.map',
        components: { base: Map },
        beforeEnter: (to, from, next) => {
            const childId = parseInt(to.params.child_id, 10);
            const isOwnChild = store.getters.userChildren.some(child => child.id === childId);
            const canEmployeeViewMap = store.getters.canViewChildMaps
                && store.getters.currentEmployee
                && !isOwnChild;

            if (canEmployeeViewMap || store.getters.canParentViewChildMaps) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        }
    }
];
